var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.clubVersion === 'v2' ? `v2-${_vm.theme}` : '',attrs:{"data-v2-theme":_vm.theme}},[(_vm.clubVersion !== 'v2' && (_vm.loadNavbar || _vm.loadSlideBar))?_c('SiteTemplate',[_c('router-view')],1):(_vm.loadNavbar)?_c('SiteTemplateV2',[_c('router-view')],1):_c('router-view'),_c('div',{staticClass:"box-notificacoes"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }